module.exports = __webpack_public_path__ + "img/ssgrama.1265220d.png";